export default __webpack_public_path__ + "static/media/about-2-comp.efe855f5.png";